import Page from "components/Page";
import { BrowserRouter } from "react-router-dom";
import React from "react";
import Routes from "Routes";
import { SessionModals } from "components/SessionModals/SessionModals";
import { SessionTestPanel } from "components/DevTools/SessionTestPanel";
import { enforceIndexedDbVersionAndInit } from "utils/indexedDbRecovery";

// import "./App.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

function App() {
	const [isDbReady, setIsDbReady] = React.useState(false);

	React.useEffect(() => {
		let cancelled = false;
		const init = async () => {
			await enforceIndexedDbVersionAndInit();
			if (!cancelled) {
				setIsDbReady(true);
			}
		};
		init();
		return () => {
			cancelled = true;
		};
	}, []);

	if (!isDbReady) {
		return null;
	}

	return (
		<Page>
			<BrowserRouter
				future={{
					v7_startTransition: true,
					v7_relativeSplatPath: true,
				}}
			>
				<SessionModals />
				{/* 測試用工具面板，後期需要移除 (Critical) */}
				{/* <SessionTestPanel /> */}
				<Routes />
			</BrowserRouter>
		</Page>
	);
}

export default App;
